import { Message } from 'stream-chat-react';
import type { RenderedMessage } from 'stream-chat-react';
import { StreamChatMessageType } from '@features/components/Chat/constants';
import type { ReactElement } from 'react';
import type { Channel, LocalMessage } from 'stream-chat';
import { isAfter } from 'date-fns';
import { renderMessage } from './renderCustomMessages';

export const createCustomMessageRenderer =
  (channel: Channel, clientUserId: string) =>
  (messages: RenderedMessage[], index: number): ReactElement => {
    const { [index]: renderedMsg } = messages;
    const message = renderedMsg as LocalMessage;
    const enriched = message.type === StreamChatMessageType.Regular ? renderMessage(message) : message;

    const readBy =
      message.id && channel.state.read
        ? Object.values(channel.state.read)
            .filter((entry) => {
              const isNotSender = entry.user?.id !== clientUserId;
              const hasReadLater = isAfter(new Date(entry.last_read), new Date(message.created_at!));
              return isNotSender && hasReadLater;
            })
            .map((entry) => entry.user)
        : [];

    return <Message message={enriched ?? { ...message, text: '' }} readBy={readBy} closeReactionSelectorOnClick />;
  };
